if (!customElements.get('n-email-popup')) {
  class NEmailPopup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.querySelectorAll('[data-email-popup-dismiss]').forEach((el) => {
        el.addEventListener('click', () => this.dismiss());
      });
      this._onKey = (event) => {
        if (event.key === 'Escape' && !this.hasAttribute('hidden')) this.dismiss();
      };
      document.addEventListener('keydown', this._onKey);
      this._onOpenRequest = (event) => {
        const trigger = event.target.closest('[data-n-open-signup]');
        if (!trigger || !this.liveDialog()) return;
        event.preventDefault();
        this.open();
      };
      document.addEventListener('click', this._onOpenRequest);

      const posted = window.location.search.indexOf('customer_posted=true') !== -1;
      const postedDialog = posted && this.querySelector(`[data-form-id="${window.location.hash.slice(1)}"]`);
      if (postedDialog) {
        this.open(postedDialog);
        window.localStorage.setItem('n-email-popup-dismissed', '1');
        return;
      }

      if (window.localStorage.getItem('n-email-popup-dismissed') === '1') return;
      const dialog = this.liveDialog();
      if (!dialog) return;
      const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : Number(dialog.dataset.delay || 8000);
      this._timer = window.setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
      if (this._onOpenRequest) document.removeEventListener('click', this._onOpenRequest);
      if (this._timer) window.clearTimeout(this._timer);
    }

    liveDialog() {
      const state = document.documentElement.getAttribute('data-n-state') || 'everyday';
      const matches = (when) =>
        !when ||
        when === 'always' ||
        when === state ||
        (when === 'sale' && (state === 'month' || state === 'week' || state === 'friday')) ||
        (when === 'not-sale' && state === 'everyday') ||
        (when === 'not-friday' && state !== 'friday');
      return Array.from(this.querySelectorAll('[data-popup-variant]')).find((dialog) =>
        matches(dialog.getAttribute('data-n-when'))
      );
    }

    open(dialog) {
      const target = dialog || this.liveDialog();
      if (!target) return;
      this.querySelectorAll('[data-popup-variant]').forEach((el) => {
        el.classList.toggle('n-email-popup__dialog--active', el === target);
      });
      this.removeAttribute('hidden');
      const close = target.querySelector('.n-email-popup__close');
      if (close) close.focus();
    }

    dismiss() {
      window.localStorage.setItem('n-email-popup-dismissed', '1');
      this.setAttribute('hidden', '');
    }
  }
  customElements.define('n-email-popup', NEmailPopup);
}
